export default __webpack_public_path__ + "static/media/Img0018.47aaeb0f.jpg";